import React, { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Alert,
  Chip,
} from "@mui/material";
import { useUpdateUserQuery } from "../../../api/useUpdateUser";

const UserEditDialog = ({ isModalOpen, closeModal, data }) => {
  const { mutate, isError, isPending, error } = useUpdateUserQuery();
  const [formData, setFormData] = useState(data);
  const [originalData, setOriginalData] = useState({ ...data });
  const [errorMessage, setErrorMessage] = useState("");

  const queryClient = useQueryClient();
  useEffect(() => {
    if (data) {
      setFormData({ ...data });
      setOriginalData({ ...data });
    }
  }, [data]);

  const handleUpdate = () => {
    mutate(
      {
        ...formData,
        studyList: formData.studyList.map((study) => study._id),
      },
      {
        onSuccess: () => {
          closeModal(); // 성공 시 모달 닫기
          queryClient.invalidateQueries("users");
        },
        onError: (error) => {
          setErrorMessage(
            error.response.data.message || "등록에 실패했습니다."
          ); // 실패 시 에러 메시지 설정
        },
      }
    );
  };
  const handleDeleteStudy = (studyId) => {
    setFormData({
      ...formData,
      studyList: formData.studyList.filter((study) => study._id !== studyId),
    });
  };
  const handleRestoreStudyList = () => {
    setFormData({ ...formData, studyList: originalData.studyList });
  };

  return (
    <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>유저 정보 수정</DialogTitle>
      {isError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      )}
      {!formData ? (
        <Alert>데이터 없음</Alert>
      ) : (
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              marginTop: 2,
            }}
          >
            <TextField
              label="이름"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              fullWidth
            />
            <TextField
              label="이메일"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              fullWidth
            />
            <TextField
              label="사는 곳"
              value={formData.region}
              onChange={(e) =>
                setFormData({ ...formData, region: e.target.value })
              }
              fullWidth
            />
            <Box>
              {formData.studyList.map((study) => (
                <Chip
                  key={study._id}
                  label={study.title}
                  onDelete={() => handleDeleteStudy(study._id)}
                  sx={{ mr: 1, mb: 1 }}
                />
              ))}
            </Box>
            <Button onClick={handleRestoreStudyList} variant="outlined">
              리스트 복원하기
            </Button>
          </Box>
        </DialogContent>
      )}

      <DialogActions>
        <Button onClick={closeModal} disabled={isPending}>
          취소
        </Button>
        <Button onClick={handleUpdate} disabled={isPending}>
          수정하기
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserEditDialog;
